export const apis = {
    //Services
    GET_SERVICES: 'api/services',
    GET_SERVICE_BY_ID: 'api/getservicesbyid/',
};